var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep4Cbt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "step_3_CBT_up") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#888888",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CBT_up",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-9.147186, 137.852814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camera",
    transform: "translate(60.000000, 60.000000) rotate(-315.000000) translate(-60.000000, -60.000000) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120,0 L72,107 L48,107 L0,0",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.25,
    fill: "url(#linearGradient-1)",
    strokeDasharray: "6,4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(48.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8404914,3.48507125 L16.219,1 L7.78077641,1 L7.15950859,3.48507125 C6.95001824,4.32303266 6.22907469,4.92559875 5.37986081,4.99358936 L5.21922359,5 L1,5 L1,17 L23,17 L23,5 L18.7807764,5 C17.9170256,5 17.1575961,4.44672576 16.8856709,3.63935743 L16.8404914,3.48507125 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2192236,0 C16.6780912,0 17.0780743,0.312297374 17.1893661,0.757464375 L17.8106339,3.24253563 C17.9219257,3.68770263 18.3219088,4 18.7807764,4 L23,4 C23.5522847,4 24,4.44771525 24,5 L24,17 C24,17.5522847 23.5522847,18 23,18 L1,18 C0.44771525,18 0,17.5522847 0,17 L0,5 C0,4.44771525 0.44771525,4 1,4 L5.21922359,4 C5.67809124,4 6.07807434,3.68770263 6.18936609,3.24253563 L6.81063391,0.757464375 C6.92192566,0.312297374 7.32190876,0 7.78077641,0 L16.2192236,0 Z M16.8404914,3.48507125 L16.219,1 L7.78077641,1 L7.15950859,3.48507125 C6.95001824,4.32303266 6.22907469,4.92559875 5.37986081,4.99358936 L5.21922359,5 L1,5 L1,17 L23,17 L23,5 L18.7807764,5 C17.9170256,5 17.1575961,4.44672576 16.8856709,3.63935743 L16.8404914,3.48507125 Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,6 C14.7614237,6 17,8.23857625 17,11 C17,13.7614237 14.7614237,16 12,16 C9.23857625,16 7,13.7614237 7,11 C7,8.23857625 9.23857625,6 12,6 Z M12,7 C9.790861,7 8,8.790861 8,11 C8,13.209139 9.790861,15 12,15 C14.209139,15 16,13.209139 16,11 C16,8.790861 14.209139,7 12,7 Z",
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,8.5 C12.2761424,8.5 12.5,8.72385763 12.5,9 C12.5,9.27614237 12.2761424,9.5 12,9.5 C11.1715729,9.5 10.5,10.1715729 10.5,11 C10.5,11.2761424 10.2761424,11.5 10,11.5 C9.72385763,11.5 9.5,11.2761424 9.5,11 C9.5,9.61928813 10.6192881,8.5 12,8.5 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 18,
    y: 6,
    width: 3,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 2,
    y: 2,
    width: 3,
    height: 1,
    rx: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(144.852814, 137.852814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camera",
    transform: "translate(60.000000, 60.000000) rotate(-45.000000) translate(-60.000000, -60.000000) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120,0 L72,107 L48,107 L0,0",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.25,
    fill: "url(#linearGradient-1)",
    strokeDasharray: "6,4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(48.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8404914,3.48507125 L16.219,1 L7.78077641,1 L7.15950859,3.48507125 C6.95001824,4.32303266 6.22907469,4.92559875 5.37986081,4.99358936 L5.21922359,5 L1,5 L1,17 L23,17 L23,5 L18.7807764,5 C17.9170256,5 17.1575961,4.44672576 16.8856709,3.63935743 L16.8404914,3.48507125 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2192236,0 C16.6780912,0 17.0780743,0.312297374 17.1893661,0.757464375 L17.8106339,3.24253563 C17.9219257,3.68770263 18.3219088,4 18.7807764,4 L23,4 C23.5522847,4 24,4.44771525 24,5 L24,17 C24,17.5522847 23.5522847,18 23,18 L1,18 C0.44771525,18 0,17.5522847 0,17 L0,5 C0,4.44771525 0.44771525,4 1,4 L5.21922359,4 C5.67809124,4 6.07807434,3.68770263 6.18936609,3.24253563 L6.81063391,0.757464375 C6.92192566,0.312297374 7.32190876,0 7.78077641,0 L16.2192236,0 Z M16.8404914,3.48507125 L16.219,1 L7.78077641,1 L7.15950859,3.48507125 C6.95001824,4.32303266 6.22907469,4.92559875 5.37986081,4.99358936 L5.21922359,5 L1,5 L1,17 L23,17 L23,5 L18.7807764,5 C17.9170256,5 17.1575961,4.44672576 16.8856709,3.63935743 L16.8404914,3.48507125 Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,6 C14.7614237,6 17,8.23857625 17,11 C17,13.7614237 14.7614237,16 12,16 C9.23857625,16 7,13.7614237 7,11 C7,8.23857625 9.23857625,6 12,6 Z M12,7 C9.790861,7 8,8.790861 8,11 C8,13.209139 9.790861,15 12,15 C14.209139,15 16,13.209139 16,11 C16,8.790861 14.209139,7 12,7 Z",
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,8.5 C12.2761424,8.5 12.5,8.72385763 12.5,9 C12.5,9.27614237 12.2761424,9.5 12,9.5 C11.1715729,9.5 10.5,10.1715729 10.5,11 C10.5,11.2761424 10.2761424,11.5 10,11.5 C9.72385763,11.5 9.5,11.2761424 9.5,11 C9.5,9.61928813 10.6192881,8.5 12,8.5 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 18,
    y: 6,
    width: 3,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 2,
    y: 2,
    width: 3,
    height: 1,
    rx: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Table",
    transform: "translate(51.000000, 0.000000)",
    fill: "#D6D1AB",
    stroke: "#000100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.717203,0.282796544 L153.717203,12.5844462 L137.893806,12.5844462 L137.893806,6.15082482 L132.383259,6.15082482 L132.383259,12.5844462 L21.6167415,12.5844462 L21.6167415,6.15082482 L16.1061943,6.15082482 L16.1061943,12.5844462 L0.282796544,12.5844462 L0.282796544,0.282796544 L153.717203,0.282796544 Z",
    id: "Combined-Shape",
    strokeWidth: 0.565593087
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.5,
    x: 72.7288991,
    y: 28.88315,
    width: 8.61284404,
    height: 1.05538099
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.565593087,
    x: 25.7139892,
    y: 12.5844462,
    width: 102.572022,
    height: 16.3315004
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.46858,29.9057345 L105.46858,144.509034 C105.46858,145.426616 105.096656,146.257331 104.495337,146.85865 C103.894017,147.459969 103.063302,147.831893 102.14572,147.831893 L102.14572,147.831893 L51.924922,147.831893 C51.0073397,147.831893 50.1766249,147.459969 49.5753056,146.85865 C48.9739863,146.257331 48.6020626,145.426616 48.6020626,144.509034 L48.6020626,144.509034 L48.6020626,29.9057345 L105.46858,29.9057345 Z",
    id: "Rectangle",
    strokeWidth: 0.565593087
  })), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 1,
    x2: 240,
    y2: 1,
    id: "Line",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "square"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4Cbt);
export default __webpack_public_path__ + "static/media/step_4_CBT.771a60e1aa9b996dda9cfee0844b4979.svg";
export { ForwardRef as ReactComponent };